<template>
    <div class="af-search-no-results afu-flex afu-flex-start afu-flex-col afu-bg-gray-200 afu-py-4 afu-px-4 afu-rounded">
        <div class="af-search-no-results-title afu-text-danger-400">
            {{ $t('search_results.not_found') }}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SearchNoResults',

        data() {
            return {};
        },

        methods: {},
    };
</script>
